"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    ", ";\n"], ["\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n        width: ", "px;\n        height: ", "px;\n        background: ", ";\n        border-radius: ", "px;\n        float: left;\n        box-shadow: 0px 0px 0 ", "px\n            ", ";\n        padding: ", "px;\n        margin-bottom: 20px;\n        cursor: pointer;\n        position: relative;\n    "], ["\n        width: ", "px;\n        height: ", "px;\n        background: ", ";\n        border-radius: ", "px;\n        float: left;\n        box-shadow: 0px 0px 0 ", "px\n            ", ";\n        padding: ", "px;\n        margin-bottom: 20px;\n        cursor: pointer;\n        position: relative;\n    "]),
    _templateObject3 = _taggedTemplateLiteral(["\n        width: ", "vw;\n        min-width: ", "px;\n        height: ", "px;\n        background: ", ";\n        margin: ", "px\n            0;\n        margin-left: ", "px;\n        position: relative;\n        right: ", "px;\n        float: left;\n        box-shadow: 0 ", "px 0\n                ", ",\n            0 -", "px 0 0 ", ";\n        padding: ", "px ", "px\n            ", "px 0;\n        z-index: 1;\n    "], ["\n        width: ", "vw;\n        min-width: ", "px;\n        height: ", "px;\n        background: ", ";\n        margin: ", "px\n            0;\n        margin-left: ", "px;\n        position: relative;\n        right: ", "px;\n        float: left;\n        box-shadow: 0 ", "px 0\n                ", ",\n            0 -", "px 0 0 ", ";\n        padding: ", "px ", "px\n            ", "px 0;\n        z-index: 1;\n    "]),
    _templateObject4 = _taggedTemplateLiteral(["\n        width: 100%;\n        height: 100%;\n        border-radius: ", "%;\n        transition: 50ms linear;\n        transition-delay: 50ms;\n        color: ", ";\n        position: relative;\n        z-index: 2;\n        ", ";\n    "], ["\n        width: 100%;\n        height: 100%;\n        border-radius: ", "%;\n        transition: 50ms linear;\n        transition-delay: 50ms;\n        color: ", ";\n        position: relative;\n        z-index: 2;\n        ", ";\n    "]),
    _templateObject5 = _taggedTemplateLiteral(["\n                background: ", ";\n                color: ", ";\n            "], ["\n                background: ", ";\n                color: ", ";\n            "]),
    _templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"], ["\n    ", ";\n    ", ";\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n        width: 0;\n        height: 100%;\n        border-top-radius: 20px;\n        margin-left: -", "px;\n        padding-right: ", "px;\n        box-sizing: content-box;\n        transition: 100ms linear;\n    "], ["\n        width: 0;\n        height: 100%;\n        border-top-radius: 20px;\n        margin-left: -", "px;\n        padding-right: ", "px;\n        box-sizing: content-box;\n        transition: 100ms linear;\n    "]),
    _templateObject8 = _taggedTemplateLiteral(["\n            background: ", ";\n            width: 100%;\n        "], ["\n            background: ", ";\n            width: 100%;\n        "]),
    _templateObject9 = _taggedTemplateLiteral(["\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n"], ["\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n        left: 50%;\n        position: absolute;\n        white-space: nowrap;\n        transform: translateX(-50%);\n        color: ", ";\n        font-size: 13px;\n        bottom: -18px;\n    "], ["\n        left: 50%;\n        position: absolute;\n        white-space: nowrap;\n        transform: translateX(-50%);\n        color: ", ";\n        font-size: 13px;\n        bottom: -18px;\n    "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Circle = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject2, props.theme.steps.circleDiameter, props.theme.steps.circleDiameter, props.theme.steps.backgroundColor, props.theme.steps.borderRadius, props.theme.steps.border, props.theme.steps.borderColor, props.theme.steps.padding);
});

var Bar = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject3, props.barWidth, props.minBarWidth, props.theme.steps.barHeight, props.theme.steps.backgroundColor, (props.theme.steps.circleDiameter - props.theme.steps.barHeight) / 2, props.theme.steps.spacing * 2, props.theme.steps.spacing, props.theme.steps.border, props.theme.steps.borderColor, props.theme.steps.border, props.theme.steps.borderColor, props.theme.steps.padding, props.theme.steps.padding, props.theme.steps.padding);
});

var CircleInner = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject4, props.theme.steps.borderRadius, props.theme.steps.progressColor, function (props) {
        return props.active && (0, _styledComponents.css)(_templateObject5, props.theme.steps.progressColor, props.theme.steps.backgroundColor);
    });
});

var BarInner = _styledComponents2.default.div(_templateObject6, function (props) {
    return (0, _styledComponents.css)(_templateObject7, props.theme.steps.padding, props.theme.steps.padding * 3);
}, function (props) {
    return props.active && (0, _styledComponents.css)(_templateObject8, props.theme.steps.progressColor);
});

var Icon = _styledComponents2.default.div(_templateObject9);

var Label = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject10, props.theme.steps.labelColor);
});

var Steps = function (_React$Component) {
    _inherits(Steps, _React$Component);

    function Steps() {
        _classCallCheck(this, Steps);

        return _possibleConstructorReturn(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).apply(this, arguments));
    }

    _createClass(Steps, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                i = _props.i,
                onClick = _props.onClick,
                current = _props.current,
                hasBar = _props.hasBar,
                barWidth = _props.barWidth,
                minBarWidth = _props.minBarWidth,
                label = _props.label;


            return [_react2.default.createElement(
                Circle,
                { onClick: onClick, key: "step_cicle_" + i },
                _react2.default.createElement(
                    CircleInner,
                    { active: i <= current },
                    _react2.default.createElement(
                        Icon,
                        null,
                        this.props.children
                    )
                ),
                label && _react2.default.createElement(
                    Label,
                    null,
                    label
                )
            ), hasBar && _react2.default.createElement(
                Bar,
                {
                    barWidth: barWidth,
                    minBarWidth: minBarWidth,
                    key: "step_bar_" + i
                },
                _react2.default.createElement(BarInner, { active: i < current })
            )];
        }
    }]);

    return Steps;
}(_react2.default.Component);

Steps = (0, _styledComponents.withTheme)(Steps);

Steps.propTypes = {
    /** The current step */
    current: _propTypes2.default.number,
    /** Array of stages - shows the label and callback in an object. */
    stages: _propTypes2.default.array,
    /** The width of the lines between the dots */
    barWidth: _propTypes2.default.number,
    /** Min width of the lines between the dots */
    minBarWidth: _propTypes2.default.number
};

Steps.defaultProps = {
    barWidth: 10,
    minBarWidth: 60
};

Steps.displayName = "Steps";

exports.default = Steps;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/steps/step.js
// module id = 454
// module chunks = 95715928098905 168707334958949